angular.module('CarsSaraBo').factory('RatePriceService', ['$resource','DateService','$q','$http', function ($resource, dateService, $q, $http) {
	return {
		resource: $resource('../rest/company/:companyOid/rate/per-point-of-sale/:oid',
			{companyOid: '@companyOid', oid: '@oid'},
			{
				post: {method: 'POST'},
				update: {method: 'PUT'},
				remove: {method: 'DELETE'},
				get: {method: 'GET', isArray: true},
				getOne: {method: 'GET'},
				doAction: {method: 'PATCH'}
			}),

		save : function(carPrices, companyOid, pointsOfSale, periods){
			var rateOperation = this.getSaveOperationRate(carPrices, companyOid, pointsOfSale, periods);
			return $q.all([
				this.resource.doAction({companyOid: companyOid}, rateOperation).$promise,
			]);
		},

		searchPrices : function(period, companyOid, pointsOfSaleOid, carOid){
			var fields = "rangeDefinitionName,rangeDefinitionDays,period,rate,pointOfSaleOid"
			var from = dateService.customFormatDate(period.from, "yyyyMMdd");
			var to = dateService.customFormatDate(period.to, "yyyyMMdd");
			return $http.get("../rest/company/" + companyOid + "/rate/" + pointsOfSaleOid +
				"/" + carOid + "/" + from +
				"/" + to + "?fields=" + fields)
		},

		getCarRates: function (carPrices) {
			var price = {};
			var carRates = [];
			for (i in carPrices) {
				for (y in carPrices[i]) {
					price = {"rangeDefinitionOid": y, "rate": carPrices[i][y], "carOid": i};
					carRates.push(price);
				}
			}
			return carRates;
		},

		findNameOnPosList : function (posList, posOid) {
			return (_.find(posList, {oid: posOid})).name;
		},

		getPointOfSales : function (pos) {
			var pointsOfSaleOid = [];
			for (i in pos) {
				if (pos[i].checked == true) {
					pointsOfSaleOid.push(i);
				}
			}
			return pointsOfSaleOid;
		},

		getPeriods : function (from, to) {
			var periods = [];
			var period = {};
			period.from = dateService.customFormatDate(from, "yyyyMMdd");
			period.to = dateService.customFormatDate(to, "yyyyMMdd");
			periods.push(period);
			return periods;
		},

		getSaveOperationRate : function (carPrices, companyOid, pointsOfSale, periods) {
			var rateOperation = {};
			var rates = this.createRates(carPrices, companyOid, pointsOfSale, periods);
			rateOperation.rates = rates;
			rateOperation.operation = "CREATE";
			return rateOperation;
		},

		createRates : function(carPrices, companyOid, pointsOfSale, period){
			var rates = [];
			var rate = {companyOid:companyOid, pointsOfSaleOid:this.getPointOfSales(pointsOfSale),
				periods:this.getPeriods(period.from, period.to),
				carRates:this.getCarRates(carPrices)};
			rates.push(rate);
			return rates;
		}

	}
}]);




//////////////////
// WEBPACK FOOTER
// ./public/app/rate/rate_service.js
// module id = 826
// module chunks = 3